import Avatar from '../../Avatar/Avatar';
import Tooltip from '../../Tooltip/Tooltip';
import Button from '../../Button/Button';
import { mapActions, mapGetters } from 'vuex';
import Context from '@/models/Context';
import User from '@/models/core/User';
import Membership from '@/models/core/Membership';
import Team from '@/models/core/Team';

export default {
  name: 'Topbar',
  components: {
    Avatar,
    Tooltip,
    Button
  },
  props: [],
  data() {
    return {
      langs: ['en', 'nl']
    };
  },
  computed: {
    current: function() {
      if (!this.isLoading) {
        const context = Context.query()
          .where(context => {
            return context.id === 'current';
          })
          .with('user')
          .first();
        if (context.isLoaded) {
          return context;
        }
      }

      return { loaded: false };
    },

    isLoading: function() {
      return this._isLoading();
    }
  },
  beforeMount() {},
  mounted() {
    this._findMemberships();
  },
  methods: {
    ...mapActions({
      _findMemberships: 'entities/memberships/findAll'
    }),
    ...mapGetters({
      _isLoading: 'entities/context/isLoading'
    }),
    setLocale(locale) {
      this.$i18n.locale = locale;
    },
    toSettings() {
      this.$router.push({ path: '/admin/settings' });
    }
  }
};
